import React, { useEffect } from 'react'
import MainSlideCard from '../../cards/MainSlideCard'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useDispatch, useSelector } from 'react-redux';
import { getMainSlider } from '../../../services/actions/MainAction';


const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 1
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1
  },
  tablet: {
    breakpoint: { max: 1024, min: 764 },
    items: 1
  },
  mobile: {
    breakpoint: { max: 764, min: 0 },
    items: 1
  }
};
function MainSection() {
  const dispatch = useDispatch();
  const lang_id = useSelector(state => state.Data.lang_id);
  const mainSlider = useSelector(state => state.Data.mainSlider);

  useEffect(()=>{
    dispatch(getMainSlider(lang_id))
  },[lang_id])
  return (
    <div className='h-[600px] w-full relative max-[1000px]:h-auto min-h-[200px]'>
       <Carousel 
          swipeable={true}
          draggable={true}
          showDots={true}
          responsive={responsive}
          ssr={true} 
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={2000}
          keyBoardControl={true}
          customTransition="all 2s"
          transitionDuration={2000}
          containerClass="h-full"
          dotListClass="custom-dot-list-style"
          itemClass=""
          
        >
          {
            mainSlider?.map((data, i) => {
              return (
                <MainSlideCard key={i} data={data} />
              )
            })
          }
        </Carousel>
      
    </div>
  )
}

export default MainSection